import { combineReducers } from "redux";
//import your reducer files here like the following two lines
import mainReducer from "./mainReducer";
import store from "./store";
import customers from "./customers";
import cart from "./cart";
import promise from "./Promise";
import PastOrders from "./PastOrders";
import branch from "./branch";
import deliveryTime from "./deliveryTime";
import staticPages from "./staticPages";
import auth from "./auth";
import currency from "./currency";
import shipping from "./shipping";
import abandonedCart from "./abandonedCart";
import b2b from "./b2b";
import feedbacks from "./feedbacks";
import productFilter from "./productFilter";
import selectedCategoryHeader from "./selectedCategoryHeader";

const rootReducer = combineReducers({
  store: store,
  customers: customers,
  cart: cart,
  root: mainReducer,
  promise: promise,
  PastOrders: PastOrders,
  branch: branch,
  deliveryTime: deliveryTime,
  staticPages: staticPages,
  auth: auth,
  selectedCategoryHeader: selectedCategoryHeader,
  currency: currency,
  shipping: shipping,
  abandonedCart: abandonedCart,
  b2b: b2b,
  feedbacks: feedbacks,
  productFilter: productFilter,
});

export default rootReducer;
